import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Router-level helper — scroll the page to the top whenever the path changes.
 * Mounted once inside <BrowserRouter>. Skips scroll-restore when the URL has
 * a hash fragment (so /legal#privacy still anchors to the section).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}
